import { handleResponse, handleError } from "./apiUtils.js";
import { generateClient } from 'aws-amplify/api';
import * as queries from '../graphql/queries.js';
// import { storedProcParameters } from './apiUtils.js';
// import util from 'util';

const client = generateClient();

/**
 * Returns an array of resources from the api using the user name and sso.
 * @param {*} name
 * @param {*} sso
 * @param {*} withDisabled
 */
export async function getFindResource(name, sso, withDisabled) {

  let findResource = await client.graphql(
    {
      query: queries.resourceApIgetResource, 
      variables: { name, sso, withDisabled }
    }
  );

  return findResource.data.resourceAPIgetResource;
};

export async function getResourcePersonnelData(resourceId) {
  let response = await client.graphql(
    {
      query: queries.resourceApIgetResourcePersonnelData, 
      variables: { resourceId }
    }
  );

  return response.data.resourceAPIgetResourcePersonnelData;
};

export async function getResourceByDates(parameters) {

  let response = await client.graphql(
    {
      query: queries.resourceApIgetResourceByDates, 
      variables: parameters 
    }
  )
    .catch(handleError);

  return response.data.resourceAPIgetResourceByDates;
}

export async function getResourceContactInfo(parameters) {

  let response = await client.graphql(
    {
      query: queries.resourceApIgetResourceContactInfo, 
      variables: parameters 
    }
  )
    .catch(handleError);
  
  return response.data.resourceAPIgetResourceContactInfo;
}
